import { IApplicationState } from '../../../../../../../../types/types';
import { ITimeTrackerState } from '../types';

export const getTimeTrackerState = (
    state: IApplicationState,
): ITimeTrackerState => {
    return state.timeTracker && state.timeTracker.start ? state.timeTracker : null;
};
